import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

//import {outstore,key} from '@/store/index';
import '@/style/global.less'
import i18n from '@/locales/useI18n'
import 'virtual:svg-icons-register'
import setupDefaultSetting from '@/utils/setupDefaultSetting'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

import "@/utils/default-passive-events"
import api from '@/utils/http/service'
import registSections from '@/views/sections/index'
import registTopo from '@/components/Topo/index'
import {onEvent,offEvent,emitEvent} from '@/utils/EventManager'
import colorpicker from '@/components/ColorPicker/picker.vue'
import 'echarts-gl'




const app = createApp(App)
app.use(Antd)
app.use(router)
app.component('a-color-picker',colorpicker)
app.config.globalProperties.$api=api
app.config.globalProperties.$on=onEvent
app.config.globalProperties.$off=offEvent
app.config.globalProperties.$emit=emitEvent
//app.use(outstore,key)
app.use(registSections)//注册自己的全局组件
app.use(registTopo)//注册组组件
app.use(i18n)
app.mount('#app')

setupDefaultSetting()

//window.env = import.meta.env.MODE
//window.log = console.log
